import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import createOrganisationRoleService from '../services/createOrganisationRoleService';
import OrganisationRoleForm from './OrganisationRoleForm';
import { mapFormToValues } from '../helpers/mapValues';

const EMPTY_ORG_ROLE = {};

const NewOrganisationRole = ({
  open,
  dispatchCreateOrganisationRolePost,
  createOrganisationRoleFetch,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body =>
      dispatchCreateOrganisationRolePost(
        mapFormToValues(body),
        () => navigate(`/organisation-roles`),
        t
      ),
    [dispatchCreateOrganisationRolePost, t, navigate]
  );

  if (!open) return null;

  return (
    <OrganisationRoleForm
      header={t('newOrganisationRole')}
      onSubmit={handleSubmit}
      submitProcessing={createOrganisationRoleFetch.pending}
      returnRoute="/organisation-roles"
      cancelRoute="/organisation-roles"
      data={EMPTY_ORG_ROLE}
    />
  );
};

NewOrganisationRole.propTypes = {
  dispatchCreateOrganisationRolePost: PropTypes.func.isRequired,
  createOrganisationRoleFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

NewOrganisationRole.defaultProps = { open: false };

export default createOrganisationRoleService(NewOrganisationRole);
